import { twMerge } from 'tailwind-merge'

export const FieldContainer = ({
	label,
	disabled,
	fieldMessage,
	feedbackType = 'default',
	containerProps,
	htmlFor,
	required,
	children
}) => {
	return (
		<div
			{...containerProps}
			className={twMerge('w-full text-left', containerProps?.className)}
		>
			<div
				className={twMerge(
					'w-full !rounded-lg !border border-solid border-gray-300 !bg-white !px-4 !py-2 text-left transition-all duration-300 focus-within:border-gray-700',
					!label && '!py-4',
					disabled && '!pointer-events-none !cursor-auto !bg-gray-100',
					FEEDBACK_COLORS[feedbackType]?.border
				)}
			>
				{label && (
					<label
						htmlFor={htmlFor}
						className={twMerge(
							'!mb-1 !text-sm !font-normal !text-orange-600',
							FEEDBACK_COLORS[feedbackType]?.text,
							disabled && '!text-gray-400'
						)}
					>
						{label}
						{required && '*'}
					</label>
				)}
				{children}
			</div>
			{fieldMessage && (
				<span
					className={twMerge(
						'!mt-1 flex w-full !pl-4 text-left text-xs !text-gray-400',
						FEEDBACK_COLORS[feedbackType]?.text
					)}
				>
					{fieldMessage}
				</span>
			)}
		</div>
	)
}

export const FEEDBACK_COLORS = {
	error: {
		text: '!text-red-700',
		border: '!border-red-700'
	}
}
